import type { FirebaseOptions } from 'firebase/app';

export type AppEnvironment = 'development' | 'staging' | 'production';

const mode = import.meta.env.MODE;
const firebaseAppEnvironment = import.meta.env.VITE_FIREBASE_APP_ENV as unknown as string | undefined;
const configuredAppEnvironment = import.meta.env.VITE_APP_ENV as unknown as string | undefined;
const firebaseApiKey = import.meta.env.VITE_FIREBASE_API_KEY as unknown as string | undefined;
const firebaseAuthDomain = import.meta.env.VITE_FIREBASE_AUTH_DOMAIN as unknown as string | undefined;
const firebaseProjectId = import.meta.env.VITE_FIREBASE_PROJECT_ID as unknown as string | undefined;
const firebaseStorageBucket = import.meta.env.VITE_FIREBASE_STORAGE_BUCKET as unknown as string | undefined;
const firebaseAppId = import.meta.env.VITE_FIREBASE_APP_ID as unknown as string | undefined;
const emulatorSetting = import.meta.env.VITE_USE_FIREBASE_EMULATORS as unknown as string | undefined;
const environmentValue = firebaseAppEnvironment ?? configuredAppEnvironment ?? 'development';
const allowsDevelopmentFallbacks = mode === 'development' || mode === 'verification' || mode === 'test';

export const appEnvironment: AppEnvironment =
  environmentValue === 'staging' || environmentValue === 'production' ? environmentValue : 'development';

export const firebaseOptions: FirebaseOptions = allowsDevelopmentFallbacks
  ? {
      apiKey: firebaseApiKey ?? 'demo-api-key',
      authDomain: firebaseAuthDomain ?? 'demo-echo-rebuild.firebaseapp.com',
      projectId: firebaseProjectId ?? 'demo-echo-rebuild',
      storageBucket: firebaseStorageBucket ?? 'demo-echo-rebuild.appspot.com',
      appId: firebaseAppId ?? '1:000000000000:web:echo-rebuild',
    }
  : {
      apiKey: firebaseApiKey!,
      authDomain: firebaseAuthDomain!,
      projectId: firebaseProjectId!,
      storageBucket: firebaseStorageBucket!,
      appId: firebaseAppId!,
    };

export const useFirebaseEmulators =
  allowsDevelopmentFallbacks &&
  (emulatorSetting === 'true' || (appEnvironment === 'development' && emulatorSetting !== 'false'));
